var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024.003",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M682.667 0h-455.11c-62.84 0-113.78 50.94-113.78 113.78v796.443c0 62.84 50.94 113.778 113.78 113.778h568.888c62.84 0 113.778-50.937 113.778-113.777V227.556L682.667 0zm-28.445 92.24L817.982 256H682.666c-15.678 0-28.444-12.766-28.444-28.443V92.24zM824.89 910.224c0 15.678-12.768 28.444-28.445 28.444h-568.89c-15.677 0-28.443-12.767-28.443-28.444V113.78c0-15.68 12.767-28.445 28.444-28.445h170.667v56.89h56.89v-56.89H568.89v142.222c0 62.84 50.938 113.778 113.778 113.778H824.89v568.89zM398.22 199.113h56.89V256h-56.89v-56.888zm-56.89-56.89h56.89v56.89h-56.89v-56.89zm0 113.778h56.89v56.89h-56.89V256zm56.89 56.89h56.89v56.89h-56.89v-56.89zm-56.89 56.89h56.89v56.888h-56.89v-56.89zm0 113.777h113.78v170.667H341.33V483.557z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.0fa0a736dc52e9bed5f121482a465c24.svg";
export { ForwardRef as ReactComponent };